import Color from 'color';

export const MAX_COLORS = 10;
export const MIN_COLORS = 5;

export default function generateColors(activeColor) {
  const chartColors = [Color(activeColor)];

  // Ensure we have at least MIN_COLORS colors (lighter colors approach white faster)
  // 120 is totally light
  const lightnessDelta = Math.min(
    0.2,
    (120 - chartColors[0].lightness()) / MIN_COLORS / 100, // 100 to convert to percentage
  );

  while (chartColors.length < MAX_COLORS) {
    chartColors.push(Color(chartColors[chartColors.length - 1]).lighten(lightnessDelta));
  }

  return chartColors;
}



// WEBPACK FOOTER //
// ./src/utils/generateColors.js